import React, { useState, useEffect } from "react";
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const patterns = [
  [1, 4],
  [0, 1, 2],
  [0, 3, 4, 5],
  [0, 2, 4, 6, 8],
  [0, 2, 6, 8],
  [1, 3, 4, 5, 7],
  [0, 1, 2, 3, 4, 5],
  [0, 2, 3, 4, 5, 6],
  [0, 1, 2, 3, 4, 5, 6],
  [0, 1, 2, 3, 4, 5, 6, 7, 8]
];

export default function SubitizingGame() {
  const [currentPatterns, setCurrentPatterns] = useState([]);
  const [inputs, setInputs] = useState(["", "", "", ""]);
  const [feedback, setFeedback] = useState(["", "", "", ""]);
  const [borderColors, setBorderColors] = useState(["", "", "", ""]);

  const getRandomPatterns = () => {
    const shuffled = [...patterns].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 4);
  };

  const generatePatterns = () => {
    setCurrentPatterns(getRandomPatterns());
    setInputs(["", "", "", ""]);
    setFeedback(["", "", "", ""]);
    setBorderColors(["", "", "", ""]);
  };

  const handleInputChange = (index, value) => {
    const newInputs = [...inputs];
    newInputs[index] = value;
    setInputs(newInputs);
  };

  const handleCheckAll = () => {
    const newFeedback = [...feedback];
    const newBorders = [...borderColors];
    let allCorrect = true;

    for (let i = 0; i < 4; i++) {
      const correct = currentPatterns[i].length === parseInt(inputs[i], 10);
      if (correct) {
        newFeedback[i] = "✅ Correct";
        newBorders[i] = "green";
      } else {
        newFeedback[i] = "❌ Try Again";
        newBorders[i] = "red";
        allCorrect = false;
      }
    }

    setFeedback(newFeedback);
    setBorderColors(newBorders);

    if (allCorrect) {
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      setTimeout(() => generatePatterns(), 1500);
    }
  };

  useEffect(() => {
    generatePatterns();
  }, []);

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Number Warmups</h1>
      <div style={styles.grid}>
        {currentPatterns.map((pattern, idx) => (
          <div key={idx} style={styles.patternBox}>
            <div style={styles.dots}>
              {Array.from({ length: 9 }).map((_, index) => (
                <div
                  key={index}
                  style={pattern.includes(index) ? styles.dot : styles.emptyDot}
                />
              ))}
            </div>
            <input
              type="text"
              placeholder="How many dots?"
              value={inputs[idx]}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  handleInputChange(idx, value);
                }
              }}
              style={{
                ...styles.input,
                borderColor: borderColors[idx] || "#ccc",
                borderWidth: "2px",
                borderStyle: "solid"
              }}
            />

            <div
              style={{
                ...styles.message,
                color: feedback[idx].includes("✅") ? "green" : "red"
              }}
            >
              {feedback[idx]}
            </div>
          </div>
        ))}
      </div>
      <button onClick={handleCheckAll} style={styles.button}>
        Check Answer
      </button>

    </div>
  );
}

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    textAlign: "center",
    padding: "1rem",
    maxWidth: "900px",
    margin: "0 auto"
  },
  title: {
    fontSize: "2rem",
    marginBottom: "1rem",
    color: "#333"
  },
  grid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "1.2rem"
  },
  patternBox: {
    border: "1px solid #ccc",
    borderRadius: "0.6rem",
    padding: "1rem",
    width: "min(40vw, 200px)",  // responsive width
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    boxSizing: "border-box"
  },
  dots: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gridTemplateRows: "repeat(3, 1fr)",
    gap: "0.4rem",
    justifyContent: "center",
    marginBottom: "0.5rem",
    aspectRatio: "1"  // keeps it square
  },
  dot: {
    width: "100%",
    height: "100%",
    background: "black",
    borderRadius: "50%"
  },
  emptyDot: {
    width: "100%",
    height: "100%"
  },
  input: {
    padding: "0.3rem",
    fontSize: "1rem",
    width: "100%",
    outline: "none",
    borderRadius: "5px"
  },
  button: {
    width: "9rem",
    height: "2.5rem",
    backgroundColor: "black",
    color: "white",
    fontSize: "1rem",
    fontWeight: "bold",
    border: "none",
    borderRadius: "0.75rem",
    cursor: "pointer",
    marginTop: "1.5rem"
  },
  message: {
    fontWeight: "bold",
    marginTop: "0.5rem",
    minHeight: "1em"
  }
};